import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseSaveRecueil: ReponseEnveloppe<boolean> = {
    reponse: true
}
